<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/409Zxu/tc-custom/9781466845909.jpg?1737767345001" alt="This image is the cover for the book China Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">China Bride
      </h1>
      <p class="bookDescription body article font2">
        <p> Beth Connor is suddenly plunged into the nightmarish world of underground Hong Kong when she is kidnapped by the Chinese Mafia while on her way to meet her fiancé's parents. A former Olympic runner, Connor makes a daring escape, only to find herself alone and bewildered in an unfamiliar and threatening world of seedy nightclubs and illicit pornography. It will take guts, street smarts, and a healthy dose of good luck for Connor to outfox the Triads still on her trail—as they are determined to teach the American Girl a lesson she'll never forget.<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Luk
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?734df724